export default {
    data() {
        return {
            Recovery: {
                auto: true,
                path: [],
                key: []
            },
        }
    },
    created() { // 修改值
        let oldPath = sessionStorage.getItem("OLDPATH");
        if(this.Recovery.path.indexOf(oldPath) == -1) return;
        let search = JSON.parse(sessionStorage.getItem("SEARCH"));
        if(!this.Recovery.auto) {
            this.Recovery.data = search;
            return;
        }
        this.Recovery.key.forEach(item => {
            if(item == "timeList") {
                this.timeList = [
                    this.$moment(search.timeList[0]).format("YYYY-MM-DD HH:mm"), 
                    this.$moment(search.timeList[1]).format("YYYY-MM-DD HH:mm")
                ]
                return;
            }
            this[item] = search[item];
        })
    },
    mounted() { //修改scrollTop
        // let oldPath = sessionStorage.getItem("OLDPATH");
        // let scrollTop = JSON.parse(sessionStorage.getItem("SEARCH")).scrollTop;
        // this.$refs.Recovery && this.$refs.Recovery.classList.add("Overflow-y-auto");
        // if(this.Recovery.path.indexOf(oldPath) == -1 || !scrollTop) return;
        // this.$refs.Recovery.classList.add("Recovery");
        // this.$nextTick(() => {
        //     let timer = null;
        //     let num = 0;
        //     timer = setInterval(() => {
        //         num++;
        //         this.$refs.Recovery.scrollTop = scrollTop;
        //         if(this.$refs.Recovery.scrollTop == scrollTop || num > 600) {
        //             this.$refs.Recovery.classList.remove("Recovery");
        //             clearInterval(timer);
        //         }
        //     })
        // })
    },
    beforeRouteEnter(to, from, next) { // 判断从哪个页面来的
        sessionStorage.setItem("OLDPATH", from.path);
        next();
    },
    beforeRouteLeave(to, from, next) { // 保存数据
        let obj = {};
        this.$refs.Recovery && this.$refs.Recovery.scrollTop && (obj.scrollTop = this.$refs.Recovery.scrollTop);
        this.Recovery.key.forEach(item => {
            obj[item] = this[item];
        })
        sessionStorage.setItem("SEARCH", JSON.stringify(obj));
        next();
    }
}